import React, { useEffect, useState } from 'react';
import { PRESS_QUOTES } from '../mock';
import { api } from '../api';
import { Star } from 'lucide-react';

const PressBar = () => {
  const [brandName, setBrandName] = useState('IGGrowth');

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const settings = await api.getPublicSettings();
        setBrandName(
          settings?.brand_name ||
          settings?.brandName ||
          'IGGrowth'
        );
      } catch (error) {
        // Keep the safe fallback if public settings are unavailable.
      }
    };

    loadSettings();
  }, []);

  const replaceBrand = (text) => {
    if (typeof text !== 'string') return text;
    return text.replace(/\{\{brand\}\}/g, brandName);
  };

  return (
    <section className="py-14">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 grid md:grid-cols-4 gap-4">
        {PRESS_QUOTES.map((p) => (
          <div
            key={p.source}
            className="p-5 rounded-2xl bg-white border border-slate-200 hover:shadow-lg transition-shadow"
          >
            <div className="flex items-center gap-1 mb-2">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-4 h-4 fill-amber-400 text-amber-400"
                />
              ))}
            </div>

            <p className="text-sm text-slate-700 italic leading-relaxed">
              “{replaceBrand(p.quote)}”
            </p>

            <p className="mt-3 text-xs font-bold text-slate-500 uppercase tracking-widest">
              — {p.source}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PressBar;
